// Mirrors backend.domain.personalization.render — replaces {{key}} with the
// context value, leaving unknown placeholders untouched.
const PATTERN = /{{\s*([a-zA-Z_][a-zA-Z0-9_.]*)\s*}}/g;

export function renderTemplate(body: string, ctx: Record<string, string>): string {
  return (body || "").replace(PATTERN, (match, key: string) => (key in ctx ? ctx[key] : match));
}

/** Recursively render {{variables}} in every string leaf — mirrors backend
 *  content_blocks.personalize_content, used for the live editor preview. */
export function personalizeData<T>(data: T, ctx: Record<string, string>): T {
  if (typeof data === "string") return renderTemplate(data, ctx) as unknown as T;
  if (Array.isArray(data)) return data.map((d) => personalizeData(d, ctx)) as unknown as T;
  if (data && typeof data === "object") {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(data)) out[k] = personalizeData(v, ctx);
    return out as T;
  }
  return data;
}
